//import NumberFormat from "react-number-format";
import parsePhoneNumber from "libphonenumber-js";

export default function PhoneNumberFormatter(props) {
  const p = parsePhoneNumber(props.children || "", "CA");
  return p ? <span>{p.formatNational()}</span> : null;
}
